import React from 'react';

import Link from 'gatsby-link';

import map from 'lodash/map';

import { withStyles } from '@material-ui/core/styles';

import Paper from '../Paper';
import Title from '../Title';

const styles = () => ({
  tagContainer: {
    display: 'inline-flex',
    marginRight: 8,
    marginBottom: 4,
    border: '1px solid #b8b8b8',
    borderRadius: 25,
    padding: 8,
    textDecoration: 'none',
    justifyContent: 'center',
    minWidth: 50,
  },
  tag: {
    color: '#b8b8b8',
    fontSize: 10,
    fontFamily: 'Raleway',
  },
});

const PopularTags = ({ classes, nodes }) => {
  return (
    <Paper>
      <Title>Popular Tags</Title>
      {map(nodes, ({ node: { id, name, slug } }) => (
        <Link
          key={`category-${id}`}
          to={`/blog/tag/${slug}`}
          className={classes.tagContainer}
        >
          <div className={classes.tag}>{name}</div>
        </Link>
      ))}
    </Paper>
  );
};

export default withStyles(styles)(PopularTags);
